<div class="toggle-slider">
    {{ placeholder }}
    <mat-button-toggle-group (change)="valueChanges($event)" class="group" multiple #group="matButtonToggleGroup">
        <mat-button-toggle value="0">0 - 1 mois</mat-button-toggle>
        <mat-button-toggle value="1">1 - 6 mois</mat-button-toggle>
        <mat-button-toggle value="6">6 - 12 mois</mat-button-toggle>
        <mat-button-toggle value="12">12 - 24 mois</mat-button-toggle>
        <mat-button-toggle value="24">24 - 36 mois</mat-button-toggle>
        <mat-button-toggle value="36">+ 36 mois</mat-button-toggle>
        <mat-button-toggle value="-1">∞</mat-button-toggle>
    </mat-button-toggle-group>
</div>